import type { Messages } from '@/i18n/messages/en/index.ts'

/**
 * `admin.settings` in Brazilian Portuguese.
 *
 * *Maker* is **criador / criadora**, so every sentence about makers here is written as
 * *quem cria* — which is the ordinary Brazilian way to say it, is shorter than the English,
 * and sidesteps having to pick a gender for a group of people whose gender nobody knows.
 *
 * The quota labels are the one place in this namespace where Portuguese runs longer than
 * English and the slot is fixed — a three-column grid of numeric fields. *Armazenamento por
 * base (MB)* is the longest of them and still fits at 360 px, because the label sits on its
 * own line above the field rather than beside it.
 */
export const settings: Messages['admin']['settings'] = {
  title: 'Política do marketplace',
  lead: 'Categorias, limites e por quanto tempo um nome descontinuado fica reservado. São valores de política — nada que quem cria envie consegue mudá-los.',
  loading: 'Carregando as configurações…',
  failed: 'Não foi possível carregar as configurações.',
  save: 'Salvar configurações',
  saving: 'Salvando…',
  saved: 'Salvo',
  saveFailed: 'Não foi possível salvar as configurações.',

  categoriesTitle: 'Categorias',
  categoriesHint: 'A taxonomia de onde quem cria escolhe. A ordem daqui é a ordem que eles veem.',

  personalTitle: 'O que uma pessoa pode ter',
  personalHint:
    'O que qualquer pessoa pode criar por conta própria. Quem cria vê estes como limites simples antes de esbarrar em um deles. As bases de conhecimento de um administrador não têm limite.',
  groupTitle: 'O que um grupo pode ter',
  groupHint:
    'Maiores, porque quem gerencia um grupo foi nomeado por um administrador, e o que um grupo guarda cresce mais do que o de uma pessoa sozinha. Mover algo para dentro de um grupo conta nos limites do grupo.',

  quotaLabels: {
    agentsPerMaker: 'Agentes',
    basesPerMaker: 'Bases de conhecimento',
    documentsPerBase: 'Documentos por base',
    storagePerBaseBytes: 'Armazenamento por base (MB)',
    agentsPerGroup: 'Agentes',
    basesPerGroup: 'Bases de conhecimento',
    documentsPerGroupBase: 'Documentos por base',
    storagePerGroupBaseBytes: 'Armazenamento por base (MB)',
    previewRunsPerMakerPerDay: 'Execuções de prévia por dia'
  },

  holdTitle: 'Reserva de nome arquivado (dias)',
  holdHint: 'Por quanto tempo uma listagem descontinuada mantém o nome antes que outra pessoa possa usá-lo.',

  add: 'Adicionar',
  addTo: (list) => `Adicionar a ${list}`,
  remove: (value) => `Remover ${value}`,
  empty: 'vazio'
}
